import { useCallback } from "react";
import useApis from "./useAPI";
import { consultationDraftUrl, consultationDraftStatusUrl } from "../utils/constants";

const buildUrl = (bookingId, serviceName) =>
  `${consultationDraftUrl}?booking_id=${encodeURIComponent(
    bookingId,
  )}&service_name=${encodeURIComponent(serviceName)}`;

const buildStatusUrl = (bookingId, serviceName) =>
  `${consultationDraftStatusUrl}?booking_id=${encodeURIComponent(
    bookingId,
  )}&service_name=${encodeURIComponent(serviceName)}`;

export const useDraftApi = () => {
  const { callApi } = useApis();

  const getDraft = useCallback(
    async (bookingId, serviceName) => {
      return callApi(null, buildUrl(bookingId, serviceName), "GET");
    },
    [callApi],
  );

  const getDraftStatus = useCallback(
    async (bookingId, serviceName) => {
      return callApi(null, buildStatusUrl(bookingId, serviceName), "GET");
    },
    [callApi],
  );

  const saveDraftSlice = useCallback(
    async (bookingId, serviceName, partialData) => {
      return callApi(partialData, buildUrl(bookingId, serviceName), "PUT");
    },
    [callApi],
  );

  const clearDraft = useCallback(
    async (bookingId, serviceName) => {
      await callApi(null, buildUrl(bookingId, serviceName), "DELETE");
    },
    [callApi],
  );

  return { getDraft, getDraftStatus, saveDraftSlice, clearDraft };
};